import {
  type ChainIdentifier,
  type FragmentOf,
  graphql,
  readFragment,
} from "@opensea/graphql"
import { getCurrencyTabById } from "./CurrencyNavigation/constants"
import type { CurrencyNavigationTab } from "./CurrencyNavigation/types"

const currencyChainIdFallbackFragment = graphql(`
  fragment currencyChainIdFallback on Currency {
    chain {
      identifier
    }
  }
`)

export function buildCurrencyUrl(
  chain: ChainIdentifier,
  contractAddress: string,
  tabId: CurrencyNavigationTab["id"] = "details",
) {
  const tab = getCurrencyTabById(tabId)
  const tokenPath = `/token/${chain}/${contractAddress}`
  return tokenPath + tab.subpath
}

export const currencyUrlFragment = graphql(`
	fragment currencyUrl on Currency {
		chainIdentifier
		contractAddress
	}
`)

export function getCurrencyUrl(
  currencyKey: FragmentOf<
    typeof currencyUrlFragment | typeof currencyChainIdFallbackFragment
  >,
  tabId: CurrencyNavigationTab["id"] = "details",
) {
  const currency = readFragment(
    currencyUrlFragment,
    currencyKey as FragmentOf<typeof currencyUrlFragment>,
  )

  let chainId = currency.chainIdentifier as ChainIdentifier | undefined
  const contract = currency.contractAddress

  if (!chainId) {
    const fallback = readFragment(
      currencyChainIdFallbackFragment,
      currencyKey as FragmentOf<typeof currencyChainIdFallbackFragment>,
    )
    chainId = fallback?.chain?.identifier as ChainIdentifier | undefined
  }

  if (!chainId) {
    return "#"
  }

  return buildCurrencyUrl(chainId as ChainIdentifier, contract, tabId)
}

const LAST_CURRENCY_NAVIGATION_TAB_KEY = "last-currency-navigation-tab"

export function setLastCurrencyNavigationTab(
  tabId: CurrencyNavigationTab["id"],
) {
  localStorage.setItem(LAST_CURRENCY_NAVIGATION_TAB_KEY, tabId)
}

export function getLastCurrencyNavigationTab():
  | CurrencyNavigationTab["id"]
  | undefined {
  if (typeof window !== "undefined") {
    const lastTabId = localStorage.getItem(LAST_CURRENCY_NAVIGATION_TAB_KEY)
    if (lastTabId) {
      return lastTabId as CurrencyNavigationTab["id"]
    }
  }
  return undefined
}
